import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactComponent } from './contact.component';
import { ThemeModule } from '../@theme/theme.module';
import { ContactRoutingModule } from './contact-routing.module';
import { ContactLayoutComponent } from './contact.layout';
import { NbButtonModule, NbCardModule } from '@nebular/theme';
import { NgxCaptchaModule } from 'ngx-captcha';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ContactLayoutComponent,
    ContactComponent
  ],
  imports: [
    ContactRoutingModule,
    CommonModule,
    ThemeModule,
    NbCardModule,
    NbButtonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
  ]
})
export class ContactModule { }
